import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import { AdminActions } from '@adapters/redux/reducer/admin';
import PageLoader from '../Loader/PageLoader';
import { ToastNotificationContext } from '@context/ToastNotificationContext';

const SOCIALS = ['tripadvisor', 'facebook', 'zalo', 'instagram', 'youtube'];

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const { ownerInfo, updateData, updating } = props;

  const [name, setName] = useState(ownerInfo?.name || '');
  const [phone1, setPhone1] = useState(ownerInfo?.phone1 || '');
  const [phone2, setPhone2] = useState(ownerInfo?.phone2 || '');
  const [address, setAddress] = useState(ownerInfo?.address || '');
  const [addressVie, setAddressVie] = useState(ownerInfo?.address_vi || '');
  const [email1, setEmail1] = useState(ownerInfo?.email1 || '');
  const [email2, setEmail2] = useState(ownerInfo?.email2 || '');
  const [addressLink, setAddressLink] = useState(ownerInfo?.address_link || '');
  const [workingHour, setWorkingHour] = useState(ownerInfo?.working_hour || '');
  const [workingHourVie, setWorkingHourVie] = useState(
    ownerInfo?.working_hour_vi || ''
  );
  const [socials, setSocials] = useState(
    SOCIALS.map((social, index) => {
      const s = ownerInfo?.socials?.find(({ name }) => name === social);
      return { id: index + 1, name: social, link: s?.link || '' };
    })
  );
  const [isShowMap, setIsShowMap] = useState(false);

  const onSubmit = () => {
    const params = {
      name,
      address,
      address_vi: addressVie,
      phone1,
      phone2,
      email1,
      email2,
      working_hour: workingHour,
      working_hour_vi: workingHourVie,
      address_link: addressLink,
      socials,
    };

    updateData('put', 'ownerInfo', params, 'ownerInfo', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        notifySuccess('Update contact successfully');
      }
    });
  };

  const onShowLinkGoogleMap = () => {
    if (addressLink) {
      setIsShowMap(true);
    }
  };

  return (
    <Fragment>
      <div className="position-relative">
        {updating && <PageLoader />}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Owner Info</h4>
                </div>
                <div className="card-body">
                  <div className="basic-form">
                    <div className="row">
                      <div className="form-group mb-3 col-md-6">
                        <label>Name</label>
                        <input
                          type="text"
                          value={name}
                          className="form-control"
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Address Link</label>
                        <input
                          type="text"
                          value={addressLink}
                          className="form-control"
                          onChange={(e) => setAddressLink(e.target.value)}
                          onBlur={onShowLinkGoogleMap}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Address (ENG)</label>
                        <input
                          type="text"
                          value={address}
                          className="form-control"
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Address (VIE)</label>
                        <input
                          type="text"
                          value={addressVie}
                          className="form-control"
                          onChange={(e) => setAddressVie(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Email (1)</label>
                        <input
                          type="text"
                          value={email1}
                          className="form-control"
                          onChange={(e) => setEmail1(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Email (2)</label>
                        <input
                          type="text"
                          value={email2}
                          className="form-control"
                          onChange={(e) => setEmail2(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Phone Number (1)</label>
                        <input
                          type="text"
                          value={phone1}
                          className="form-control"
                          onChange={(e) => setPhone1(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Phone Number (2)</label>
                        <input
                          type="text"
                          value={phone2}
                          className="form-control"
                          onChange={(e) => setPhone2(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Working hour (ENG)</label>
                        <input
                          type="text"
                          value={workingHour}
                          className="form-control"
                          onChange={(e) => setWorkingHour(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label>Working hour (VIE)</label>
                        <input
                          type="text"
                          value={workingHourVie}
                          className="form-control"
                          onChange={(e) => setWorkingHourVie(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Socials Info</h4>
                </div>
                <div className="card-body">
                  <div className="basic-form">
                    <div className="row">
                      {socials.map((social, index) => {
                        return (
                          <div key={index} className="form-group mb-3 col-md-6">
                            <label>{social.name.toUpperCase()}</label>
                            <input
                              type="text"
                              value={social.link}
                              className="form-control"
                              onChange={(e) => {
                                const value = e.target.value;
                                const stateSocials = socials;
                                stateSocials[index].link = value;
                                setSocials([...stateSocials]);
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mb-3">
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  ownerInfo: state.admin.ownerInfo,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
